import { compose, values, reduce } from 'ramda'

/**
 * @function forceUnique
 * Ensures the set of features only contains one entry per ID.
 * If there are duplicates, the last one in the array overwrites the previous ones.
 * @param {Array<Object>} features - List of features.
 * @returns {Array<Object>} List of unique features.
 */
export const forceUnique = (features) => {
  const uniqList = compose(
    values,
    reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: curr, // Use ID as the key, ensuring uniqueness
      }),
      {}
    )
  )(features)

  return uniqList
}
